/* -----------------Globals--------------- */
import { useState } from "react";

/* -----------------Helpers & Hooks--------------- */
import { router, useLocalSearchParams } from "expo-router";

import Box from "@memorang/ui/components/Box";
import ScrollContainer from "@memorang/ui/components/ScrollContainer";

import type { ApplyAccessCodeResponse } from "api/commerce/types";
/* -----------------Child components--------------- */
import RedeemCodeContainer from "./RedeemCodeContainer";
import RedeemCodeSuccessContainer from "./RedeemCodeSuccessContainer";

const RedeemCodeRouter = () => {
	const params = useLocalSearchParams<{
		step: string;
	}>();

	const currentStepParam = params?.step!;
	const [accessCodeResult, setAccessCodeResult] = useState<
		ApplyAccessCodeResponse | undefined
	>(undefined);

	const handleNext = (result: ApplyAccessCodeResponse) => {
		setAccessCodeResult(result);
		router.setParams({ step: "success" });
	};

	const lookUp: Record<string, React.ReactNode | null> = {
		redeem: <RedeemCodeContainer handleNext={handleNext} />,
		success: accessCodeResult ? (
			<RedeemCodeSuccessContainer accessCodeResult={accessCodeResult} />
		) : null,
	};

	return (
		<ScrollContainer maxWidth="xs">
			<Box paddingTop={24}>{lookUp[currentStepParam] || lookUp.redeem}</Box>
		</ScrollContainer>
	);
};

export default RedeemCodeRouter;
